import { organizationApi } from "@/core/data/api";

export default async (id) => {
  return await organizationApi.removeOrganization(id);
};
